<template>
    <header class="csrHeader">
        <div class="csrHeader__logo">
            <div class="mobileFeature">
                <fa
                    @click="toogleMobileSub"
                    v-if="!showMobileHeight"
                    class="hambuger"
                    :class="{
                        'hambuger--active': showMobileSub,
                    }"
                    icon="bars"
                />
                <figure
                    @click="toogleMobileSub"
                    class="navArrow"
                    :class="{
                        'navArrow--active': !showMobileSub,
                    }"
                    v-else
                >
                    <img src="@/assets/images/arrow.png" alt="" />
                </figure>
            </div>
            <figure class="imgBox">
                <router-link
                    @click="closeSub"
                    :to="{
                        name: 'Index',
                        params: { lang: $store.getters.getCurrentLang },
                    }"
                >
                    <img src="@/assets/msilogo.png" alt="msi logo" />
                </router-link>
            </figure>
            <div class="formLink">
                <router-link class="toForm" :to="{ name: 'FormPage' }">
                    <span>MSI CSR Report</span>
                </router-link>
            </div>
        </div>
        <nav class="navBar--mobile">
            <transition name="drop">
                <div
                    class="main"
                    :class="[showMobileHeight ? 'mainHeight' : '']"
                    v-show="showMobileSub"
                >
                    <div class="mainArea" v-show="showMobileHeight">
                        <div
                            v-for="(mainItem, index) in nav"
                            :key="mainItem.id"
                            class="mainArea__title"
                        >
                            <div class="item" @click="toogleMobileItem(index)">
                                <span>{{ mainItem.title }}</span>
                                <figure class="navArrow">
                                    <img
                                        :class="{
                                            'rotate--active':
                                                currentMobileItem === index,
                                        }"
                                        src="@/assets/images/arrow.png"
                                        alt=""
                                    />
                                </figure>
                            </div>
                            <div
                                v-show="currentMobileItem === index"
                                class="sub"
                            >
                                <SubNav
                                    :subData="mainItem.subNav"
                                    @closeNav="toogleMobileSub"
                                ></SubNav>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </nav>
    </header>
    <nav class="navBar--PC">
        <div class="main" :class="{ 'main--active': changeBackground }">
            <div class="mainArea" @click="toogleSub">
                <div
                    v-for="mainItem in nav"
                    :key="mainItem.id"
                    class="mainArea__title"
                >
                    {{ mainItem.title }}
                </div>
            </div>
        </div>
        <transition name="drop">
            <div class="sub" v-show="show">
                <transition name="fade">
                    <div
                        class="subArea"
                        v-show="showHeight"
                        :class="{ subHeight: showHeight }"
                    >
                        <div
                            v-for="mainItem in nav"
                            :key="mainItem.id"
                            class="subItem"
                            @click.self="closeSub"
                        >
                            <SubNav
                                :subData="mainItem.subNav"
                                @closeNav="closeSub"
                            ></SubNav>
                        </div>
                    </div>
                </transition>
                <transition name="fade">
                    <figure
                        class="navArrow"
                        v-show="showHeight"
                        @click="closeSub"
                    >
                        <img src="@/assets/images/arrow.png" alt="" />
                    </figure>
                </transition>
            </div>
        </transition>
    </nav>
</template>

<script>
import SubNav from "@/components/SubNav";
export default {
    name: "BaseNav",
    components: {
        SubNav,
    },
    props: {
        nav: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            show: false,
            showHeight: false,
            // changeBackground: false,
            showMobileSub: false,
            showMobileHeight: false,
            currentMobileItem: "",
        };
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.handleResize);
    },
    methods: {
        toogleSub() {
            this.show = !this.show;
            setTimeout(() => {
                this.showHeight = !this.showHeight;
            }, 200);
        },
        handleScroll() {
            const navBar = document.querySelector(".navBar--PC");
            const csrHeader = document.querySelector(".csrHeader");
            navBar.offsetTop > csrHeader.offsetHeight
                ? (this.changeBackground = true)
                : (this.changeBackground = false);
        },
        closeSub() {
            this.show = false;
            setTimeout(() => {
                this.showHeight = false;
            }, 200);
        },
        handleResize() {
            if (window.innerWidth > 960) return;
            this.closeSub();
        },
        toogleMobileSub() {
            this.showMobileSub = !this.showMobileSub;
            setTimeout(() => {
                this.showMobileHeight = !this.showMobileHeight;
            }, 300);
        },
        toogleMobileItem(index) {
            this.currentMobileItem === index
                ? (this.currentMobileItem = "")
                : (this.currentMobileItem = index);
        },
    },
};
</script>

<style lang="sass" scoped>
.drop-enter-active,
.drop-leave-active
    transition: height .8s
    height: 0

.drop-enter-to,
.drop-leave-from
    height: 100vh

.fade-enter-active,
.fade-leave-active
    transition: opacity .6s
    opacity: 0

.fade-enter-to,
.fade-leave-from
    opacity: 1

.csrHeader
    color: #fff
    font-weight: bold
    background-color: #5c5c5c
    padding: 7px 0

    position: sticky
    top: 0
    z-index: 20
    @media (min-width:960px)
        position: static
    &__logo
        width: 90%
        margin: 0 auto
        display: flex
        justify-content: space-between
        align-items: center
        @media (min-width:960px)
            width: 80%
        .toForm
            text-decoration: none
            color: #fff

        .imgBox
            a
                display: block
            img
                vertical-align: middle
                width: 100%
        .mobileFeature
            font-size: 25px
            @media (min-width:960px)
                display: none
        .hambuger
            color: #fff

            padding: 10px
            cursor: pointer
            transition-property: transform,opacity
            transition-duration: .9s, .9s
            transform: rotate(0deg)
            opacity: 1

        .hambuger--active
            transform: rotate(180deg)
            opacity: 0
        .hambuger--show
            transform: rotate(0deg)
        .navArrow
            width: 30px
            margin-left: 8px
            cursor: pointer
            transition-property: transform,opacity
            transition-duration: .9s, .9s
            transform: rotate(0deg)
            opacity: 1

            @media (min-width:960px)
                display: none
            img
                width: 100%
                vertical-align: middle
        .navArrow--active
            transform: rotate(-180deg)
            opacity: 0

.navBar--PC
    color: #fff
    font-weight: bold
    position: sticky
    top: 0
    z-index: 20
    .main
        background-color: rgb(143,143,143,87%)
    .mainArea
        display: none
        width: 85%
        margin: 0 auto
        @media (min-width: 960px)
            display: flex
            justify-content: center
            align-items: center
        &__title
            font-size: 15px
            line-height: 20px
            padding: 12px 30px
            flex: 1 0 0
            cursor: pointer
    .sub
        background-color: rgba(56, 53, 50, 83%)
        position: absolute
        top: 100%
        right: 0
        left: 0
        z-index: 20
        .subArea
            position: relative
            display: flex
            justify-content: center
            width: 85%
            margin: 15px auto 0
        .subItem
            flex: 1 0 0
            &__title
                font-size: 14px
                padding: 6px 35px
                .subNet
                    list-style-type: circle
                    padding-inline-start: 22px
    .subHeight
        height: 100vh
    .main--active
        opacity: 0.95
        background-color: #828282
    .navArrow
        width: 25px
        position: absolute
        bottom: 20%
        right: 0
        left: 0
        margin: auto
        cursor: pointer
        img
            width: 100%
            vertical-align: middle

.navBar--mobile
    color: #fff
    position: absolute
    top: 100%
    right: 0
    left: 0
    bottom: 0
    .main
        background-color: rgba(56,53,50,83%)
    .mainHeight
        height: 100vh
    .mainArea
        width: 90%
        margin: 0 auto
        &__title
            padding: 0 10px
            border-bottom: 1px solid #bbbbbb
            cursor: pointer
            .item
                display: flex
                padding: 16px 0
            .navArrow
                width: 8px
                margin-left: 8px
                img
                    width: 100%
                    vertical-align: middle
                    transition: transform .7s
                    transform: rotate(-180deg)
                .rotate--active
                    transform: rotate(0deg)
</style>
